import { NavMarker } from 'react-rhumb';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useState } from 'react';
import { Map as ImmutableMap } from 'immutable';
import * as DocumentsActions from 'documents-ui/actions/DocumentsActions';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { isMultiBrandEnabled } from 'documents-lib/js/utils/isMultiBrandEnabled';
import { trackInteraction } from 'documents-lib/js/tracking/tracker';
import { SAVE_BULK_CHANGE_BRAND } from 'documents-lib/js/tracking/actions';
import { UsageTrackingScreen } from 'documents-ui/constants/UsageTracking';
import FormattedMessage from 'I18n/components/FormattedMessage';
import partial from 'transmute/partial';
import UserContainer from 'documents-ui/lib/containers/UserContainer';
import { canWrite } from 'documents-ui/lib/permissions';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
import IndexTableColumns from 'documents-ui/lib/IndexTableColumns';
import DocumentsTableRow from 'documents-ui/components/tableRow/DocumentsTableRow';
import DocumentsFolderRow from 'documents-ui/components/tableRow/DocumentsFolderRow';
import DocumentsEmptyState from 'documents-ui/components/DocumentsEmptyState';
import DeleteModal from './DeleteModal';
import BulkChangeBrandModal from 'documents-ui/components/brand/BulkChangeBrandModal';
import DocumentDescriptionPanel from 'documents-ui/components/description/DocumentDescriptionPanel';
import * as SearchApi from 'documents-ui/api/SearchApi';
import createConnectedIndexTableContainer from 'SalesContentIndexUI/containers/createConnectedIndexTableContainer';
import createFolderNavModal from 'SalesContentIndexUI/components/folderNav/createFolderNavModal';
import RenameFolderTableActionButton from 'SalesContentIndexUI/components/tableActionButtons/RenameFolderTableActionButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { ListItem } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { FolderIcon } from 'foundations-assets/icons/components/FolderIcon';
import { SwitcherIcon } from 'foundations-assets/icons/components/SwitcherIcon';
import { rethrowError } from 'UIComponents/core/PromiseHandlers';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const searchFetch = SearchApi.search;
const folderContentType = SearchContentTypes.DOCUMENTS_FOLDER;
const SuccessMarker = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "INDEX_LOAD"
});
const FailureMarker = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "INDEX_FAIL"
});
const DocumentsIndexTableContainer = createConnectedIndexTableContainer({
  searchFetch,
  folderContentType,
  looseItemContentType: SearchContentTypes.DOCUMENT,
  getUserId: () => UserContainer.get().user_id,
  getTeamIds: () => {
    const {
      teams
    } = UserContainer.get();
    return teams.length ? teams.map(team => team.id) : null;
  },
  tableColumns: IndexTableColumns,
  EmptyState: DocumentsEmptyState,
  TableRow: DocumentsTableRow,
  FolderRow: DocumentsFolderRow,
  useOwnerViewFilters: true
});
const DocumentsIndexTable = ({
  count,
  saveFolder,
  deleteFolders,
  removeDocuments,
  moveDocuments,
  batchUpdateDocumentsBrand,
  history,
  location,
  deckId,
  deckTitle,
  description,
  toggleDocumentDescription
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showFolderNavModal, setShowFolderNavModal] = useState(false);
  const [showBulkChangeBrandModal, setShowBulkChangeBrandModal] = useState(false);
  const [selectedResults, setSelectedResults] = useState(ImmutableMap());
  const renderFolderTableActionButtons = selectedFolders => {
    if (!canWrite()) {
      return null;
    }
    return /*#__PURE__*/_jsxs(List, {
      inline: true,
      marginInlineStart: "200",
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(RenameFolderTableActionButton, {
          selectedFolder: selectedFolders.first(),
          disabled: selectedFolders.size > 1,
          onRenameSuccess: saveFolder
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "300",
        children: /*#__PURE__*/_jsxs(Button, {
          use: "link",
          onClick: partial(deleteFolders, selectedFolders),
          children: [/*#__PURE__*/_jsx(DeleteIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "table.actionButtons.delete"
          })]
        })
      })]
    });
  };
  const renderDeleteModal = () => {
    return showDeleteModal && /*#__PURE__*/_jsx(DeleteModal, {
      onConfirm: () => {
        setShowDeleteModal(false);
        removeDocuments(selectedResults).catch(rethrowError);
      },
      onReject: () => {
        setShowDeleteModal(false);
      },
      documentsToDelete: selectedResults.toList()
    });
  };
  const renderSearchResultTableActionButtons = selectedTableResults => {
    if (!canWrite()) {
      return null;
    }
    return /*#__PURE__*/_jsxs(List, {
      inline: true,
      marginInlineStart: "200",
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsxs(Button, {
          use: "link",
          onClick: () => {
            setShowFolderNavModal(true);
            setSelectedResults(selectedTableResults);
          },
          children: [/*#__PURE__*/_jsx(Flex, {
            marginInlineEnd: "100",
            children: /*#__PURE__*/_jsx(FolderIcon, {})
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "table.actionButtons.moveToFolder"
          })]
        })
      }), isMultiBrandEnabled() && /*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "300",
        children: /*#__PURE__*/_jsxs(Button, {
          use: "link",
          onClick: () => {
            setShowBulkChangeBrandModal(true);
            setSelectedResults(selectedTableResults);
          },
          children: [/*#__PURE__*/_jsx(Flex, {
            marginInlineEnd: "100",
            children: /*#__PURE__*/_jsx(SwitcherIcon, {})
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "table.actionButtons.changeBrand"
          })]
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "300",
        children: /*#__PURE__*/_jsxs(Button, {
          use: "link",
          onClick: () => {
            setShowDeleteModal(true);
            setSelectedResults(selectedTableResults);
          },
          children: [/*#__PURE__*/_jsx(Flex, {
            marginInlineEnd: "100",
            children: /*#__PURE__*/_jsx(DeleteIcon, {})
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "table.actionButtons.delete"
          })]
        })
      })]
    });
  };
  const renderDocumentDescriptionPanel = () => {
    return description.isPanelOpen && /*#__PURE__*/_jsx(DocumentDescriptionPanel, {
      deckId: deckId,
      description: description,
      title: deckTitle,
      toggleDocumentDescription: toggleDocumentDescription
    });
  };
  const renderFolderNavPanel = () => {
    if (!showFolderNavModal) {
      return null;
    }
    const FolderNavModal = createFolderNavModal(searchFetch, folderContentType);
    return /*#__PURE__*/_jsx(FolderNavModal, {
      searchResults: selectedResults,
      onConfirm: selectedFolder => {
        setShowFolderNavModal(false);
        return moveDocuments(selectedResults, selectedFolder);
      },
      onClose: () => {
        setShowFolderNavModal(false);
      }
    });
  };
  const renderBulkChangeBrandModal = () => {
    return showBulkChangeBrandModal && /*#__PURE__*/_jsx(BulkChangeBrandModal, {
      onConfirm: brandId => {
        return batchUpdateDocumentsBrand(selectedResults, brandId).then(() => {
          setShowBulkChangeBrandModal(false);
          trackInteraction(SAVE_BULK_CHANGE_BRAND, UsageTrackingScreen.INDEX);
        }).catch(error => {
          Raven.captureException(error, {
            extra: {
              context: 'Batch update documents brand error'
            }
          });
        });
      },
      onReject: () => setShowBulkChangeBrandModal(false)
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DocumentsIndexTableContainer, {
      SuccessMarker: SuccessMarker,
      FailureMarker: FailureMarker,
      renderFolderTableActionButtons: renderFolderTableActionButtons,
      renderSearchResultTableActionButtons: renderSearchResultTableActionButtons,
      count: count,
      history: history,
      location: location,
      isDocumentsMultiBrandEnabled: isMultiBrandEnabled()
    }), renderDeleteModal(), renderDocumentDescriptionPanel(), renderFolderNavPanel(), renderBulkChangeBrandModal()]
  });
};
export default connect(state => {
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  return {
    deckId: state.documents.deckId,
    deckTitle: state.documents.deckTitle,
    description: isUngatedToChirp ? state.documents.descriptionCHIRP : state.documents.description
  };
}, Object.assign({}, DocumentsActions))(withRouter(DocumentsIndexTable));